import { useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import MaleAvatar17 from "../assets/Male Avatar 17.png";
import "./CreateChallenges.css";
import { TiUserAdd } from "react-icons/ti";
import {
  addChallenges,
  fetchChallenges,
  updateChallenges,
  useCheckSessionHeartBeat,
} from "components/API/ApiEnpoints";
import Loader from "components/Loaders/Loader";
import { toZoneDateTime } from "components/utils/DateUtils";
import moment from "moment";
import openNotification from "components/utils/CustomNotification";
import Flatpickr from "react-flatpickr";
import type { Instance as FlatpickrInstance } from "flatpickr/dist/types/instance";
import flatpickr from "flatpickr";
import Inputmask from "inputmask";
import axios from "axios";
import { Button } from "antd";
import { Checkbox, Divider, Card, Typography } from "antd";
import { getCachedImage, cacheImage } from "./imagecache";
import coinIcon from "../assets/coin.png"; // Add this line
import styled from "styled-components";
import Cropper from "react-easy-crop";
Modal.setAppElement("#root");

const CropModalContainer = styled.div`
  position: fixed;
  inset: 0;
  background: black;
  z-index: 3000;
  display: flex;
  flex-direction: column;

  .crop-wrap {
    flex: 1;
    position: relative;
  }

  .controls {
    height: 100px;
    background: #222;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 20px;

    input[type="range"] {
      width: 80%;
      max-width: 400px;
    }

    .buttons {
      display: flex;
      gap: 16px;
      button {
        padding: 8px 24px;
        border-radius: 20px;
        border: none;
        background: white;
        font-weight: 600;
        cursor: pointer;
        &.cancel {
          background: #444;
          color: white;
        }
      }
    }
  }
`;

interface IndividualOption {
  value: string;
  label: string;
  image: string;
  role: string;
}

interface TeamOption {
  name: string;
  location: string;
}

interface RewardDistribution {
  position: number;
  reward_type: string;
  value?: number | string;
  voucher_unit?: string | null;
}

const CreateChallenges = () => {
  useCheckSessionHeartBeat();
  const beAddress =
    window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;
  const location = useLocation();
  const challengeRecord = (location.state as { challenge?: any })?.challenge;
  const [backgroundImage, setBackgroundImage] = useState<string | null>(null);
  const [metricType, setMetricType] = useState<string>("steps");
  const [type, setType] = useState<string>("individual");
  const [visibility, setVisibility] = useState<string>("private");
  const [count, setCount] = useState<string | number>("");
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [startDateTime, setStartDateTime] = useState<Date | null>(null);
  const [endDateTime, setEndDateTime] = useState<Date | null>(null);
  const [lastRegistrationDate, setLastRegistrationDate] = useState<Date | null>(
    null,
  );
  const [goalEvaluationMode, setGoalEvaluationMode] = useState("");

  const [maxParticipants, setMaxParticipants] = useState<string>("");
  const isEditMode = !!challengeRecord;
  const [assignIndividual, setAssignIndividual] = useState<
    { value: string; label: string }[]
  >([]);
  const [assignTeam, setAssignTeam] = useState<
    { value: string; label: string }[]
  >([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<"individual" | "team" | null>(
    null,
  );
  const inputRef = useRef<HTMLInputElement | null>(null);
  const timezone = localStorage.getItem("timeZone") ?? "UTC";
  const navigate = useNavigate();
  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";
  const orgUid = localStorage.getItem("org_uid") || "";
  const [isLoading, setIsLoading] = useState(false);

  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [imgDimensions, setImgDimensions] = useState<{
    width: number;
    height: number;
  } | null>(null);
  const [tempImageForCrop, setTempImageForCrop] = useState<string | null>(null);

  // Reward-related states (new array-based approach)
  const [isRewardModalOpen, setIsRewardModalOpen] = useState(false);
  const [currentPositionIndex, setCurrentPositionIndex] = useState<
    number | null
  >(null);
  const [isRewardDistributionLocked, setIsRewardDistributionLocked] =
    useState(false);

  const [assignRewards, setAssignRewards] = useState<boolean>(false); // switch
  const [rewardPositions, setRewardPositions] = useState<string>(""); // default 1

  const [totalRewards, setTotalRewards] = useState<string>(""); // total reward pool (number)
  const [rewardDistributionDate, setRewardDistributionDate] =
    useState<Date | null>(null);

  const [participationPoints, setParticipationPoints] = useState("");
  const [isExperiencePoint, setIsExperiencePoint] = useState(false);
  const [participationChecked, setParticipationChecked] = useState(false);

  const [rewards, setRewards] = useState<
    {
      position: number;
      reward_type: string;
      reward_value: number | string;
      voucher_unit?: string | null;
      points?: string;
      reward_uid?: string;
      reward_name?: string;
      reward_amount?: number;
    }[]
  >([]);

  const [enablePositionRewards, setEnablePositionRewards] = useState(false);
  const [availableRewards, setAvailableRewards] = useState<{
    voucher: any[];
    coupon: any[];
  }>({ voucher: [], coupon: [] });

  const areAllPositionsAssigned = () => {
    if (!enablePositionRewards || rewards.length === 0) return true;

    return rewards.every((reward, idx) => {
      // Check if either:
      // 1. reward_value is assigned (voucher/coupon UID), OR
      // 2. points are assigned in pointsValues
      const hasVoucherOrCoupon =
        reward.reward_value !== "" &&
        reward.reward_value !== null &&
        reward.reward_value !== undefined;
      const hasPoints =
        pointsValues[idx] !== undefined &&
        pointsValues[idx] !== "" &&
        Number(pointsValues[idx]) > 0;

      return hasVoucherOrCoupon || hasPoints;
    });
  };
  const openRewardModal = (positionIndex: number) => {
    setCurrentPositionIndex(positionIndex);
    setIsRewardModalOpen(true);
  };
  const handleRewardSelection = (selectedReward: any) => {
    if (currentPositionIndex !== null) {
      handleRewardChange(
        currentPositionIndex,
        "reward_value",
        selectedReward.reward_uid,
      );
      setIsRewardModalOpen(false);
      setCurrentPositionIndex(null);
    }
  };

  // Other states
  const [rulesList, setRulesList] = useState<any[]>([]);
  const [showRules, setShowRules] = useState(false);
  const [rules, setRules] = useState<any[]>([]);
  const [selectedRules, setSelectedRules] = useState<string[]>([]);
  const [showRulesList, setShowRulesList] = useState(false);
  const [challengeDropdownConfig, setChallengeDropdownConfig] =
    useState<any>(null);

  const [base64Image, setBase64Image] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [originalData, setOriginalData] = useState<any>(null);
  const [selectedRewardUids, setSelectedRewardUids] = useState<string[]>([]);
  const [showPointsInput, setShowPointsInput] = useState<{
    [key: number]: boolean;
  }>({});

  const [pointsValues, setPointsValues] = useState<{ [key: number]: string }>(
    {},
  );
  const [rangeValidationErrors, setRangeValidationErrors] = useState<{
    [key: number]: { min?: string; max?: string };
  }>({});
  const [showDateChangeConfirm, setShowDateChangeConfirm] = useState(false);
  const [pendingDistributionDate, setPendingDistributionDate] =
    useState<Date | null>(null);

  // Helper function to safely convert date values for Flatpickr
  const safeDateForFlatpickr = (
    dateValue: Date | string | null | undefined,
  ): Date[] => {
    try {
      if (!dateValue) return [];

      // If it's already a valid Date object
      if (dateValue instanceof Date) {
        if (!isNaN(dateValue.getTime())) {
          return [dateValue];
        }
        return [];
      }

      // If it's a string, try to parse it
      if (typeof dateValue === "string" && dateValue.trim() !== "") {
        const parsed = new Date(dateValue);
        if (!isNaN(parsed.getTime())) {
          return [parsed];
        }
      }

      // If all else fails, return empty array
      return [];
    } catch (e) {
      console.error("Error converting date for Flatpickr:", e);
      return [];
    }
  };

  // Helper to generate stable keys for Flatpickr components
  const getDateKey = (dateValue: Date | null, prefix: string): string => {
    if (!dateValue) return `${prefix}-null`;
    try {
      if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
        return `${prefix}-${dateValue.getTime()}`;
      }
    } catch (e) {
      // ignore
    }
    return `${prefix}-invalid`;
  };

  // Image upload handler (kept as you had it)
  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    // Check file size (5MB = 5 * 1024 * 1024 bytes)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes

    if (file.size > maxSize) {
      openNotification({
        type: "error",
        message: "Image size exceeds 5MB limit. Please choose a smaller image.",
      });

      // Clear the input
      if (inputRef.current) {
        inputRef.current.value = "";
      }

      // Clear preview and state
      if (previewImage) {
        URL.revokeObjectURL(previewImage);
      }
      setPreviewImage(null);
      setBase64Image(null);
      setSelectedFile(null);
      return;
    }

    // Check file type
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    if (!allowedTypes.includes(file.type)) {
      openNotification({
        type: "error",
        message:
          "Invalid file type. Please upload an image (JPEG, PNG, GIF, WebP).",
      });

      // Clear the input
      if (inputRef.current) {
        inputRef.current.value = "";
      }
      return;
    }

    // Read file and open crop modal
    const readFileAsDataURL = (inputFile: File): Promise<string> =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => reject(new Error("FileReader error"));
        reader.readAsDataURL(inputFile);
      });

    const loadImage = (src: string): Promise<HTMLImageElement> =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("Image failed to load"));
        img.src = src;
      });

    try {
      const base64String = await readFileAsDataURL(file);
      const img = await loadImage(base64String);
      setImgDimensions({ width: img.naturalWidth, height: img.naturalHeight });
      setTempImageForCrop(base64String);
      setIsCropModalOpen(true);
    } catch (err) {
      console.error("Image upload error", err);
      openNotification({ type: "error", message: "Failed to load image." });
    }
  };

  // Handle crop save
  const handleCropSave = async () => {
    if (!tempImageForCrop || !croppedAreaPixels) return;

    try {
      const croppedImage = await getCroppedImg(
        tempImageForCrop,
        croppedAreaPixels,
      );

      // Set the cropped image as preview and base64
      setPreviewImage(croppedImage);
      setBase64Image(croppedImage);

      openNotification({
        type: "success",
        message: "Image cropped successfully!",
      });
    } catch (error) {
      console.error("Error saving crop", error);
      openNotification({
        type: "error",
        message: "An error occurred while cropping the image.",
      });
    }

    setIsCropModalOpen(false);
    setTempImageForCrop(null);
    if (inputRef.current) inputRef.current.value = "";
  };

  // Get cropped image
  const getCroppedImg = (imageSrc: string, pixelCrop: any): Promise<string> => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return reject("No ctx");
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          pixelCrop.width,
          pixelCrop.height,
        );
        resolve(canvas.toDataURL("image/jpeg", 0.95));
      };
      image.onerror = reject;
    });
  };

  const validatePositiveInteger = (value: string): boolean => {
    if (value === "") return true;
    const num = Number(value);
    return Number.isInteger(num) && num >= 0;
  };

  useEffect(() => {
    if (challengeRecord) {
      setOriginalData({
        challenge_name: challengeRecord.challenge_name,
        challenge_desc: challengeRecord.challenge_desc,
        challenge_type: challengeRecord.challenge_type,
        metric_type: challengeRecord.metric_type,
        goal_count: challengeRecord.goal_count,
        from_datetime: challengeRecord.from_datetime
          ? new Date(challengeRecord.from_datetime).toISOString()
          : null,
        to_datetime: challengeRecord.to_datetime
          ? new Date(challengeRecord.to_datetime).toISOString()
          : null,
        last_registration_date: challengeRecord.last_registration_date
          ? new Date(challengeRecord.last_registration_date).toISOString()
          : null,
        visibility: challengeRecord.visibility,
        max_participants: challengeRecord.max_participants,
        has_rewards: challengeRecord.has_rewards,
        challenge_rewards: challengeRecord.challenge_rewards,
        goal_evaluation_mode: challengeRecord.goal_evaluation_mode,
        image: challengeRecord.image?.image_uid || null,
        rule_uids: challengeRecord.rules?.map((r: any) => r.rule_uid) || [],
        // ADD THIS LINE:
        reward_distribution_datetime:
          challengeRecord.reward_distribution_datetime || null,
      });
    }
  }, [challengeRecord]);

  useEffect(() => {
    const fetchDropdownConfig = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/challenges-dropdown-filter`,
          {
            headers: {
              "Content-Type": "application/json",
              "user-uid": localStorage.getItem("user_uid") || "",
              "org-uid": localStorage.getItem("org_uid") || "",
            },
            withCredentials: true,
          },
        );

        if (response.data.status === "Success") {
          const configData = response.data.data;
          setChallengeDropdownConfig(configData);

          // ONLY set default values if NOT in edit mode
          if (!challengeRecord) {
            setGoalEvaluationMode(
              configData.goal_evaluation_mode?.options?.[0] || "",
            );
            setMetricType(configData.metric_types?.[0] || "");
            setCount(
              configData.config?.[configData.metric_types?.[0]]?.goal_count
                ?.values?.[0] || "",
            );
            setType(configData.challenge_type?.options?.[0] || "");
            setVisibility(configData.visibility?.options?.[0] || "");
          }
        }
      } catch (error) {
        console.error("Error fetching challenge dropdown config:", error);
      }
    };

    fetchDropdownConfig();
  }, [challengeRecord]); // Add challengeRecord as dependency

  // Add this useEffect after your fetchDropdownConfig useEffect
  useEffect(() => {
    if (challengeRecord && challengeDropdownConfig) {
      console.log("Populating form from challenge record with config:", {
        goal_count: challengeRecord.goal_count,
        metric_type: challengeRecord.metric_type,
        config_available: !!challengeDropdownConfig,
      });

      // 1. Basic challenge info
      setName(challengeRecord.challenge_name || "");
      setDescription(challengeRecord.challenge_desc || "");
      setType(challengeRecord.challenge_type || "");
      setMetricType(challengeRecord.metric_type || "");
      setVisibility(challengeRecord.visibility || "");
      setGoalEvaluationMode(
        challengeRecord.goal_evaluation_mode ||
          challengeDropdownConfig.goal_evaluation_mode?.options?.[0] ||
          "",
      );

      // 2. Goal count - CRITICAL: Set directly from record
      if (
        challengeRecord.goal_count !== undefined &&
        challengeRecord.goal_count !== null
      ) {
        setCount(challengeRecord.goal_count.toString());
      } else {
        // Fallback to config default if record doesn't have it
        const defaultCount =
          challengeDropdownConfig?.config?.[challengeRecord.metric_type]
            ?.goal_count?.values?.[0] ?? "";
        setCount(defaultCount);
      }

      // 3. Max participants
      setMaxParticipants(String(challengeRecord.max_participants || ""));

      // 4. Date fields with error handling
      if (challengeRecord.from_datetime) {
        try {
          setStartDateTime(new Date(challengeRecord.from_datetime));
        } catch (e) {
          console.error("Error parsing start datetime:", e);
          setStartDateTime(null);
        }
      } else {
        setStartDateTime(null);
      }

      if (challengeRecord.to_datetime) {
        try {
          setEndDateTime(new Date(challengeRecord.to_datetime));
        } catch (e) {
          console.error("Error parsing end datetime:", e);
          setEndDateTime(null);
        }
      } else {
        setEndDateTime(null);
      }

      if (challengeRecord.last_registration_date) {
        try {
          setLastRegistrationDate(
            new Date(challengeRecord.last_registration_date),
          );
        } catch (e) {
          console.error("Error parsing last registration date:", e);
          setLastRegistrationDate(null);
        }
      } else {
        setLastRegistrationDate(null);
      }

      // 5. Reward distribution date
      if (challengeRecord.reward_distribution_datetime) {
        try {
          setRewardDistributionDate(
            new Date(challengeRecord.reward_distribution_datetime),
          );
        } catch (e) {
          console.error("Error parsing reward distribution datetime:", e);
          setRewardDistributionDate(null);
        }
      } else {
        setRewardDistributionDate(null);
      }

      // 6. Participation points
      if (
        challengeRecord.participation_point != null &&
        challengeRecord.participation_point !== "" &&
        challengeRecord.participation_point > 0
      ) {
        setParticipationChecked(true);
        setParticipationPoints(challengeRecord.participation_point.toString());
        setIsExperiencePoint(challengeRecord.is_experience_point || false);
      } else {
        setParticipationChecked(false);
        setParticipationPoints("");
        setIsExperiencePoint(false); // Explicitly set to false when no participation points
      }

      // 7. Assign rewards flag
      if (challengeRecord.has_rewards) {
        setAssignRewards(true);
      } else {
        setAssignRewards(false);
      }

      // 8. Handle reward distribution data
      if (challengeRecord.has_rewards) {
        setAssignRewards(true);

        if (challengeRecord.reward_distribution_datetime) {
          try {
            setRewardDistributionDate(
              new Date(challengeRecord.reward_distribution_datetime),
            );
          } catch (e) {
            console.error("Error parsing reward distribution datetime:", e);
          }
        }

        // Handle reward distribution array
        if (
          Array.isArray(challengeRecord.reward_distribution) &&
          challengeRecord.reward_distribution.length > 0
        ) {
          const rewardDist = challengeRecord.reward_distribution;

          // Separate position, range, and participation rewards
          const positionRewards = rewardDist.filter(
            (r: any) => r?.distribution_type === "position",
          );
          const rangeRewards = rewardDist.filter(
            (r: any) => r?.distribution_type === "range",
          );

          // Handle position-based rewards
          if (positionRewards.length > 0) {
            setEnablePositionRewards(true);
            setRewardPositions(positionRewards.length.toString());

            const mappedPositionRewards = positionRewards.map((dist: any) => {
              const rewardsArray = dist?.rewards || [];
              const voucherCouponReward = rewardsArray.find(
                (r: any) =>
                  r.reward_type === "voucher" || r.reward_type === "coupon",
              );

              // Map API reward_type to dropdown value
              let mappedRewardType = "";
              if (voucherCouponReward?.reward_type === "voucher") {
                mappedRewardType = "vouchers";
              } else if (voucherCouponReward?.reward_type === "coupon") {
                mappedRewardType = "coupon";
              }

              return {
                position: dist?.value || 0,
                reward_type: mappedRewardType,
                reward_value: voucherCouponReward?.reward_uid || "",
                voucher_unit: null,
                reward_uid: voucherCouponReward?.reward_uid,
                reward_name: voucherCouponReward?.reward_name,
                reward_amount: voucherCouponReward?.reward_amount,
              };
            });

            setRewards(mappedPositionRewards);

            // Set points values and show points input
            const newPointsValues: { [key: number]: string } = {};
            const newShowPointsInput: { [key: number]: boolean } = {};
            const rewardUids: string[] = [];

            positionRewards.forEach((dist: any, idx: number) => {
              const rewardsArray = dist?.rewards || [];

              // Find points reward
              const pointsReward = rewardsArray.find(
                (r: any) => r.reward_type === "points",
              );

              // Find voucher/coupon reward
              const voucherCouponReward = rewardsArray.find(
                (r: any) =>
                  r.reward_type === "voucher" || r.reward_type === "coupon",
              );

              if (voucherCouponReward?.reward_uid) {
                rewardUids.push(voucherCouponReward.reward_uid);
              }

              if (pointsReward) {
                newPointsValues[idx] =
                  pointsReward.reward_amount != null
                    ? pointsReward.reward_amount.toString()
                    : "";
                newShowPointsInput[idx] = true;
              }
            });

            setPointsValues(newPointsValues);
            setShowPointsInput(newShowPointsInput);
            setSelectedRewardUids(rewardUids);
          }

          // Handle range-based rewards
          if (rangeRewards.length > 0) {
            setEnableRangeRewards(true);

            const mappedRangeRewards = rangeRewards.map((dist: any) => {
              const reward = dist?.rewards?.[0] || {};
              const value = dist?.value || {};
              return {
                min: value.range_min != null ? value.range_min.toString() : "",
                max: value.range_max != null ? value.range_max.toString() : "",
                points:
                  reward.reward_amount != null
                    ? reward.reward_amount.toString()
                    : "",
              };
            });

            setRangeRewards(mappedRangeRewards);
          }
        }
      }

      console.log("Form populated with count:", challengeRecord.goal_count);
    }
  }, [challengeRecord, challengeDropdownConfig]); // Run when both are available

  const getChangedFields = (original: any, updated: any) => {
    const changed: any = {};

    for (const key in updated) {
      // Special handling for reward_distribution_datetime
      if (key === "reward_distribution_datetime") {
        const originalDate = original[key];
        const updatedDate = updated[key];

        // If updatedDate is undefined (meaning we deliberately removed it),
        // don't include it in changed fields at all
        if (updatedDate === undefined) {
          continue;
        }

        // Handle null/empty comparisons
        const originalIsEmpty =
          originalDate === null ||
          originalDate === undefined ||
          originalDate === "";

        const updatedIsEmpty =
          updatedDate === null ||
          updatedDate === undefined ||
          updatedDate === "";

        // If both are empty, no change
        if (originalIsEmpty && updatedIsEmpty) {
          continue;
        }

        // If one is empty and the other is not, it's a change
        if (originalIsEmpty !== updatedIsEmpty) {
          // IMPORTANT: When changing from a date to null, send empty string to clear it
          changed[key] = updatedIsEmpty ? "" : updatedDate;
          continue;
        }

        // If both have values, compare them
        if (!originalIsEmpty && !updatedIsEmpty) {
          if (updatedDate !== originalDate) {
            changed[key] = updatedDate;
          }
        }
        continue;
      }

      // For arrays, do a deep comparison
      if (Array.isArray(original[key]) && Array.isArray(updated[key])) {
        if (
          JSON.stringify(original[key].sort()) !==
          JSON.stringify(updated[key].sort())
        ) {
          changed[key] = updated[key];
        }
      } else if (typeof original[key] === "object" && original[key] !== null) {
        // For objects, stringify for comparison
        if (JSON.stringify(original[key]) !== JSON.stringify(updated[key])) {
          changed[key] = updated[key];
        }
      } else {
        // For primitive values, direct comparison
        if (original[key] !== updated[key]) {
          changed[key] = updated[key];
        }
      }
    }

    return changed;
  };

  const fetchAvailableRewards = async (
    rewardType: string,
    distributionDate?: Date | null,
    isEditMode: boolean = false,
  ) => {
    const dateToUse = distributionDate || rewardDistributionDate;

    if (!dateToUse) {
      console.log("No distribution date set");
      return;
    }

    console.log(
      "Fetching rewards for type:",
      rewardType,
      "in edit mode:",
      isEditMode,
    );

    try {
      // In edit mode, we need BOTH mapped and unused rewards
      if (isEditMode) {
        // Fetch mapped rewards (already assigned to this challenge)
        const mappedParams: any = {
          expiry_datetime: dateToUse.toISOString(),
          reward_status: "mapped",
          challenge_uid: challengeRecord?.challenge_uid, // Important: filter by current challenge
        };

        // Fetch unused rewards (available for assignment)
        const unusedParams: any = {
          expiry_datetime: dateToUse.toISOString(),
          reward_status: "unused",
          // Optional: exclude rewards already mapped to other challenges if needed
        };

        // Fetch both in parallel
        const [mappedResponse, unusedResponse] = await Promise.all([
          axios.get(`${beAddress}/api/rewards`, {
            params: mappedParams,
            headers: {
              "user-uid": userUid,
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }),
          axios.get(`${beAddress}/api/rewards`, {
            params: unusedParams,
            headers: {
              "user-uid": userUid,
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }),
        ]);

        // Combine results
        let combinedRewards: any[] = [];

        if (mappedResponse.data.status === "Success") {
          combinedRewards = [
            ...combinedRewards,
            ...(mappedResponse.data.data || []),
          ];
        }

        if (unusedResponse.data.status === "Success") {
          // Filter out duplicates (rewards that are both mapped and unused shouldn't happen, but just in case)
          const unusedRewards = unusedResponse.data.data || [];
          const mappedUids = new Set(
            combinedRewards.map((r: any) => r.reward_uid),
          );
          const uniqueUnused = unusedRewards.filter(
            (r: any) => !mappedUids.has(r.reward_uid),
          );
          combinedRewards = [...combinedRewards, ...uniqueUnused];
        }

        // Process and set rewards
        await processAndSetRewards(combinedRewards, rewardType);
      } else {
        // In create mode, only fetch unused rewards
        const params: any = {
          expiry_datetime: dateToUse.toISOString(),
          reward_status: "unused",
        };

        const response = await axios.get(`${beAddress}/api/rewards`, {
          params,
          headers: {
            "user-uid": userUid,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        if (response.data.status === "Success") {
          await processAndSetRewards(response.data.data || [], rewardType);
        }
      }
    } catch (error) {
      console.error("Error fetching rewards:", error);
      // Set empty array on error
      if (rewardType === "voucher") {
        setAvailableRewards((prev) => ({ ...prev, voucher: [] }));
      } else if (rewardType === "coupon") {
        setAvailableRewards((prev) => ({ ...prev, coupon: [] }));
      }
    }
  };

  // Helper function to process rewards and fetch images
  const processAndSetRewards = async (
    rawRewards: any[],
    rewardType: string,
  ) => {
    if (!rawRewards || rawRewards.length === 0) {
      if (rewardType === "voucher") {
        setAvailableRewards((prev) => ({ ...prev, voucher: [] }));
      } else if (rewardType === "coupon") {
        setAvailableRewards((prev) => ({ ...prev, coupon: [] }));
      }
      return;
    }

    // Extract Image UIDs from the response
    const imageUidsToFetch = rawRewards
      .map((r: any) => r.image_details?.image_uid)
      .filter((uid: string) => uid);

    // Fetch the actual Base64 images
    const imagesMap = await fetchImagesByUid(imageUidsToFetch);

    // Merge images back into the reward objects
    const rewardsWithImages = rawRewards.map((r: any) => ({
      ...r,
      image: r.image_details?.image_uid
        ? imagesMap[r.image_details.image_uid]
        : null,
    }));

    // Update state
    if (rewardType === "voucher") {
      setAvailableRewards((prev) => ({
        ...prev,
        voucher: rewardsWithImages,
      }));
    } else if (rewardType === "coupon") {
      setAvailableRewards((prev) => ({
        ...prev,
        coupon: rewardsWithImages,
      }));
    }
  };

  useEffect(() => {
    if (!challengeDropdownConfig || !metricType) return;

    // Only set default count when creating NEW challenge (not editing)
    if (!challengeRecord) {
      const firstCount =
        challengeDropdownConfig?.config?.[metricType]?.goal_count
          ?.values?.[0] ?? "";
      setCount(firstCount);
    }
  }, [metricType, challengeDropdownConfig, challengeRecord]); // Add challengeRecord dependency

  // Sync rewardPositions to rewards array
  useEffect(() => {
    if (!challengeDropdownConfig) return;
    if (rewardPositions === "" || rewardPositions === null) {
      setRewards([]);
      return;
    }
    const rp = Number(rewardPositions);
    if (isNaN(rp)) return;

    setRewards((prev) => {
      const newArr = [...prev];
      while (newArr.length < rp) {
        newArr.push({
          position: newArr.length + 1,
          reward_type: challengeDropdownConfig?.reward_type?.options?.[0] || "",
          reward_value:
            challengeDropdownConfig?.reward_value?.values?.[0] ?? "",
          voucher_unit:
            challengeDropdownConfig?.voucher_unit?.options?.[0] ?? null,
        });
      }
      return newArr.slice(0, rp).map((r, idx) => ({ ...r, position: idx + 1 }));
    });
  }, [rewardPositions, challengeDropdownConfig]);

  // onInputReady for Flatpickr inputs (kept)
  const onInputReady = (
    input: HTMLInputElement,
    setDate: (date: string) => void,
  ) => {
    input.placeholder = "yyyy-mm-dd hh:mm";
    Inputmask("9999-99-99 99:99", { placeholder: "yyyy-mm-dd hh:mm" }).mask(
      input,
    );
    input.addEventListener("blur", () => {
      const value = input.value;
      const parsedDate = flatpickr.parseDate(value, "Y-m-d H:i");
      if (parsedDate && !isNaN(parsedDate.getTime())) {
        setDate(parsedDate.toISOString());
      }
    });
    input.addEventListener("focus", (event) => {
      const target = event.target as HTMLInputElement;
      if (target.value.trim() === "") return;
      const start = target.selectionStart ?? 0;
      const end = target.selectionEnd ?? 0;
      const newValue =
        target.value.substring(0, start) + target.value.substring(end);
      target.value = newValue;
    });
  };

  // Rules config fetch (kept)
  const getRulesConfig = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/rules-config?rule_type=challenge`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "user-uid": localStorage.getItem("user_uid") || "",
            "org-uid": localStorage.getItem("org_uid") || "",
          },
          credentials: "include",
        },
      );

      const result = await response.json();
      if (result.status === "Success") {
        setRules(result.data);
        setShowRulesList(true);
      }
    } catch (error) {
      console.error("Error fetching rules config:", error);
    }
  };

  // Fetch images by uid helper (kept)
  const fetchImagesByUid = async (
    imageUids: string[],
  ): Promise<Record<string, string>> => {
    if (!imageUids || imageUids.length === 0) {
      return {};
    }

    try {
      const url = new URL(`${beAddress}/api/get-image-by-uid`);
      imageUids.forEach((uid) =>
        url.searchParams.append("image_uid_list", uid),
      );
      url.searchParams.set("is_icon_img", "false");
      url.searchParams.set("is_feedback_image", "false");

      const res = await fetch(url.toString(), {
        headers: {
          "user-uid": userUid,
        },
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === "Success" && Array.isArray(data.data)) {
        return Object.fromEntries(
          data.data.map((item: any) => {
            if (item.default) return [item.image_uid, ""];
            return [item.image_uid, item.image];
          }),
        );
      }
    } catch (err) {
      console.error("Failed to fetch images:", err);
    }
    return {};
  };

  // Load existing challenge record in edit mode (kept & adapted to new reward schema)
  const getChallengeRecord = async () => {
    const params = { challenge_uid: challengeRecord.challenge_uid };
    const challengeApiResponse = await fetchChallenges(
      sessionUid,
      userUid,
      params,
    );
    if (
      Object.keys(challengeApiResponse).length !== 0 &&
      challengeApiResponse.status === "Success"
    ) {
      const data = challengeApiResponse.data[0];

      setName(data.challenge_name);
      setDescription(data.challenge_desc);
      setType(data.challenge_type);
      setMetricType(data.metric_type);
      // Set start date with error handling
      if (data.from_datetime) {
        try {
          setStartDateTime(new Date(data.from_datetime));
        } catch (e) {
          console.error("Error parsing start datetime:", e);
          setStartDateTime(null);
        }
      } else {
        setStartDateTime(null);
      }

      // Set end date with error handling
      if (data.to_datetime) {
        try {
          setEndDateTime(new Date(data.to_datetime));
        } catch (e) {
          console.error("Error parsing end datetime:", e);
          setEndDateTime(null);
        }
      } else {
        setEndDateTime(null);
      }

      // Set last registration date with error handling
      if (data.last_registration_date) {
        try {
          setLastRegistrationDate(new Date(data.last_registration_date));
        } catch (e) {
          console.error("Error parsing last registration date:", e);
          setLastRegistrationDate(null);
        }
      } else {
        setLastRegistrationDate(null);
      }

      setVisibility(data.visibility);
      setCount(data.goal_count);
      setMaxParticipants(String(data.max_participants || ""));

      if (data.reward_distribution_datetime) {
        try {
          setRewardDistributionDate(
            new Date(data.reward_distribution_datetime),
          );
        } catch (e) {
          console.error("Error parsing reward_distribution_datetime:", e);
          setRewardDistributionDate(null);
        }
      } else if (data.challenge_rewards?.[0]?.reward_distribution_datetime) {
        // Also check in challenge_rewards array
        try {
          setRewardDistributionDate(
            new Date(data.challenge_rewards[0].reward_distribution_datetime),
          );
        } catch (e) {
          console.error(
            "Error parsing challenge_rewards reward_distribution_datetime:",
            e,
          );
          setRewardDistributionDate(null);
        }
      } else {
        setRewardDistributionDate(null);
      }

      if (
        data.participation_point != null &&
        data.participation_point !== "" &&
        data.participation_point > 0
      ) {
        setParticipationChecked(true);
        setParticipationPoints(data.participation_point.toString());
        setIsExperiencePoint(data.is_experience_point || false);
      } else {
        setParticipationChecked(false);
        setParticipationPoints("");
        setIsExperiencePoint(false);
      }

      // Set assign rewards flag based on has_rewards
      if (data.has_rewards) {
        setAssignRewards(true);
      } else {
        setAssignRewards(false);
      }

      const prizePoolData = data.prize_pool;
      // if you want to set prize pool: setPrizePool(prizePoolData?.total_amounts || "");

      // handle rewards -> convert to our rewards array if present
      const rewardData = data.challenge_rewards?.[0];
      if (rewardData) {
        setAssignRewards(true);
        setTotalRewards(
          String(rewardData.total_rewards ?? rewardData.total_points ?? ""),
        );
        const positions = rewardData.reward_positions;
        setRewardPositions(positions != null ? positions.toString() : "1");
        if (rewardData.reward_distribution_datetime) {
          try {
            setRewardDistributionDate(
              new Date(rewardData.reward_distribution_datetime),
            );
          } catch (e) {
            console.error(
              "Error parsing reward distribution datetime from challenge_rewards:",
              e,
            );
            setRewardDistributionDate(null);
          }
        } else {
          setRewardDistributionDate(null);
        }
        if (Array.isArray(rewardData.distributions)) {
          const mapped = rewardData.distributions.map(
            (d: any, idx: number) => ({
              position: d.position ?? idx + 1,
              reward_type:
                d.reward_type ??
                challengeDropdownConfig?.reward_type?.options?.[0] ??
                "",
              reward_value:
                d.value ??
                d.points ??
                challengeDropdownConfig?.reward_value?.values?.[0] ??
                "",
              voucher_unit: d.voucher_unit ?? null,
            }),
          );
          setRewards(mapped);
          setRewardPositions(mapped.length);
        } else {
          // fallback: create default rows
          const count = Number(rewardPositions);
          setRewards(
            Array.from({ length: count }, (_, i) => ({
              position: i + 1,
              reward_type:
                challengeDropdownConfig?.reward_type?.options?.[0] || "",
              reward_value:
                challengeDropdownConfig?.reward_value?.values?.[0] ?? "",
              voucher_unit:
                challengeDropdownConfig?.voucher_unit?.options?.[0] ?? null,
            })),
          );
        }
      } else {
        setAssignRewards(false);
      }

      // Handle has_rewards flag and reward_distribution
      if (data.has_rewards) {
        setAssignRewards(true);

        // Set reward distribution datetime
        if (data.reward_distribution_datetime) {
          try {
            setRewardDistributionDate(
              new Date(data.reward_distribution_datetime),
            );
          } catch (e) {
            console.error("Error parsing reward distribution datetime:", e);
          }
        }

        // Handle reward distribution array
        if (
          Array.isArray(data.reward_distribution) &&
          data.reward_distribution.length > 0
        ) {
          const rewardDist = data.reward_distribution;

          // Separate position, range, and participation rewards
          const positionRewards = rewardDist.filter(
            (r: any) => r?.distribution_type === "position",
          );
          const rangeRewards = rewardDist.filter(
            (r: any) => r?.distribution_type === "range",
          );

          // Handle position-based rewards
          if (positionRewards.length > 0) {
            setEnablePositionRewards(true);
            setRewardPositions(positionRewards.length.toString());

            const mappedPositionRewards = positionRewards.map((dist: any) => {
              const rewardsArray = dist?.rewards || [];
              // Find voucher/coupon reward (not points)
              const voucherCouponReward = rewardsArray.find(
                (r: any) =>
                  r.reward_type === "voucher" || r.reward_type === "coupon",
              );

              // Map API reward_type to dropdown value (voucher -> vouchers, coupon stays coupon)
              let mappedRewardType = "";
              if (voucherCouponReward?.reward_type === "voucher") {
                mappedRewardType = "vouchers";
              } else if (voucherCouponReward?.reward_type === "coupon") {
                mappedRewardType = "coupon";
              }

              return {
                position: dist?.value || 0,
                reward_type: mappedRewardType,
                reward_value: voucherCouponReward?.reward_uid || "",
                voucher_unit: null,
                reward_uid: voucherCouponReward?.reward_uid,
                reward_name: voucherCouponReward?.reward_name,
                reward_amount: voucherCouponReward?.reward_amount,
              };
            });

            setRewards(mappedPositionRewards);

            // Set points values and show points input for all positions
            const newPointsValues: { [key: number]: string } = {};
            const newShowPointsInput: { [key: number]: boolean } = {};
            const rewardUids: string[] = [];

            positionRewards.forEach((dist: any, idx: number) => {
              const reward = dist?.rewards?.[0];
              if (!reward) return;

              // If it's a voucher or coupon, add to selected UIDs
              if (
                reward.reward_type === "voucher" ||
                reward.reward_type === "coupon"
              ) {
                if (reward.reward_uid) {
                  rewardUids.push(reward.reward_uid);
                }
              }

              // If it's points, set the points value and show input
              if (reward.reward_type === "points") {
                newPointsValues[idx] =
                  reward.reward_amount != null
                    ? reward.reward_amount.toString()
                    : "";
                newShowPointsInput[idx] = true;
              }
            });

            setPointsValues(newPointsValues);
            setShowPointsInput(newShowPointsInput);
            setSelectedRewardUids(rewardUids);

            // Fetch the actual voucher/coupon details to populate availableRewards
            if (rewardUids.length > 0 && data.reward_distribution_datetime) {
              try {
                const distDate = new Date(data.reward_distribution_datetime);

                // Determine the reward types we need to fetch
                const voucherRewards = positionRewards.filter(
                  (dist: any) => dist?.rewards?.[0]?.reward_type === "voucher",
                );
                const couponRewards = positionRewards.filter(
                  (dist: any) => dist?.rewards?.[0]?.reward_type === "coupon",
                );

                // Fetch vouchers if needed (in edit mode, fetch all rewards to show mapped ones)
                if (voucherRewards.length > 0) {
                  fetchAvailableRewards("voucher", distDate, true);
                }

                // Fetch coupons if needed (in edit mode, fetch all rewards to show mapped ones)
                if (couponRewards.length > 0) {
                  fetchAvailableRewards("coupon", distDate, true);
                }
              } catch (e) {
                console.error(
                  "Error parsing distribution date for rewards fetch:",
                  e,
                );
              }
            }
          }

          // Handle range-based rewards
          if (rangeRewards.length > 0) {
            setEnableRangeRewards(true);

            const mappedRangeRewards = rangeRewards.map((dist: any) => {
              const reward = dist?.rewards?.[0] || {};
              const value = dist?.value || {};
              return {
                min: value.range_min != null ? value.range_min.toString() : "",
                max: value.range_max != null ? value.range_max.toString() : "",
                points:
                  reward.reward_amount != null
                    ? reward.reward_amount.toString()
                    : "",
              };
            });

            setRangeRewards(mappedRangeRewards);
          }
        }
      }

      // Handle participation rewards
      // Check if participation_point has a value (not just has_participation_point flag)
      if (
        data.participation_point != null &&
        data.participation_point !== "" &&
        data.participation_point > 0
      ) {
        setParticipationChecked(true);
        setParticipationPoints(data.participation_point.toString());
        setIsExperiencePoint(data.is_experience_point || false);
      } else {
        setParticipationChecked(false);
        setParticipationPoints("");
        setIsExperiencePoint(false);
      }

      // IMAGE HANDLING WITH CACHE (kept)
      if (data.image_details?.image_uid) {
        try {
          const cached = await getCachedImage(data.challenge_uid);
          if (
            cached &&
            cached.blob &&
            String(cached.timestamp).trim() ===
              String(data.image_details.timestamp).trim()
          ) {
            const objectURL = URL.createObjectURL(cached.blob);
            setPreviewImage(objectURL);
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64Data = reader.result?.toString().split(",")[1];
              if (base64Data) setBase64Image(base64Data);
            };
            reader.readAsDataURL(cached.blob);
          } else {
            const fetchedImages = await fetchImagesByUid([
              data.image_details.image_uid,
            ]);
            const base64Img = fetchedImages[data.image_details.image_uid];
            if (base64Img) {
              await cacheImage(
                data.challenge_uid,
                data.image_details.image_uid,
                base64Img,
                data.image_details.timestamp,
              );
              const newCached = await getCachedImage(data.challenge_uid);
              const objectURL = newCached
                ? URL.createObjectURL(newCached.blob)
                : null;
              setPreviewImage(objectURL);
              setBase64Image(base64Img);
            } else {
              setPreviewImage(null);
              setBackgroundImage(null);
              setBase64Image(null);
            }
          }
        } catch (e) {
          console.error("Error fetching/caching image:", e);
          setPreviewImage(null);
          setBackgroundImage(null);
          setBase64Image(null);
        }
      } else {
        setPreviewImage(null);
        setBackgroundImage(null);
        setBase64Image(null);
      }

      setSelectedRules(data.rules || []);
    }
  };

  // Format date helper (kept)
  const formatDateTime = (date: Date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const h = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    return `${y}-${m}-${d} ${h}:${min}`;
  };

  type RangeReward = {
    min: string;
    max: string;
    points: string;
  };

  const [enableRangeRewards, setEnableRangeRewards] = useState(false);
  const [rangeRewards, setRangeRewards] = useState<RangeReward[]>([]);

  const addRangeReward = () => {
    setRangeRewards([...rangeRewards, { min: "", max: "", points: "" }]);
  };

  const handleRangeChange = (
    index: number,
    field: keyof RangeReward,
    value: string,
  ) => {
    const updated = [...rangeRewards];
    updated[index][field] = value;
    setRangeRewards(updated);
  };

  // Helper function to check if ranges overlap or are invalid
  const validateRangeRewards = (
    currentIndex: number,
    field: "min" | "max",
    value: string,
  ) => {
    if (value === "") return { isValid: true, message: "" };

    const numValue = parseInt(value);
    const usedPositions = parseInt(rewardPositions) || 0;
    const maxAllowed = parseInt(maxParticipants) || 100;

    // Check if min should be greater than usedPositions
    if (field === "min" && numValue <= usedPositions) {
      return {
        isValid: false,
        message: `Min position must be greater than ${usedPositions} (after position-based rewards)`,
      };
    }

    // Check if value exceeds max participants
    if (numValue > maxAllowed) {
      return {
        isValid: false,
        message: `Value cannot exceed ${maxAllowed} (max participants)`,
      };
    }

    // Create a temporary array with the new value
    const tempRanges = rangeRewards.map((r, idx) => {
      if (idx === currentIndex) {
        return { ...r, [field]: value };
      }
      return r;
    });

    const currentRange = tempRanges[currentIndex];
    const currentMin = parseInt(currentRange.min) || 0;
    const currentMax = parseInt(currentRange.max) || 0;

    // Check if min > max for current range
    if (currentMin && currentMax && currentMin > currentMax) {
      return {
        isValid: false,
        message: "Min position cannot be greater than max position",
      };
    }

    // Check for overlaps with other ranges
    for (let i = 0; i < tempRanges.length; i++) {
      if (i === currentIndex) continue;

      const otherRange = tempRanges[i];
      const otherMin = parseInt(otherRange.min);
      const otherMax = parseInt(otherRange.max);

      if (!otherMin || !otherMax || !currentMin || !currentMax) continue;

      // Check if ranges overlap
      const overlaps = currentMin <= otherMax && currentMax >= otherMin;

      if (overlaps) {
        return {
          isValid: false,
          message: `Range overlaps with Range ${
            i + 1
          } (${otherMin}-${otherMax})`,
        };
      }
    }

    return { isValid: true, message: "" };
  };

  // Handler for confirming distribution date change
  const handleConfirmDateChange = () => {
    if (pendingDistributionDate) {
      setRewardDistributionDate(pendingDistributionDate);
      // Clear rewards
      setRewards([]);
      setRangeRewards([]);
      setRangeValidationErrors({});
      setParticipationPoints("");
      setIsExperiencePoint(false);
      setEnablePositionRewards(false);
      setEnableRangeRewards(false);
      setParticipationChecked(false);
      setShowPointsInput({});
      setPointsValues({});
      setSelectedRewardUids([]);
      setAvailableRewards({ voucher: [], coupon: [] });

      openNotification({
        type: "info",
        message:
          "Reward distribution date updated. All reward configurations have been cleared.",
      });
    }
    setShowDateChangeConfirm(false);
    setPendingDistributionDate(null);
  };

  // Handler for canceling distribution date change
  const handleCancelDateChange = () => {
    setShowDateChangeConfirm(false);
    setPendingDistributionDate(null);
  };

  useEffect(() => {
    if (location.state) {
      getChallengeRecord();
      getRulesConfig();
    }
  }, [location.state]);

  // Basic form validation
  const isBasicFormValid =
    name.trim() &&
    description.trim() &&
    metricType &&
    count &&
    startDateTime &&
    endDateTime &&
    lastRegistrationDate &&
    type &&
    visibility &&
    Number(maxParticipants) > 0 &&
    Number.isInteger(Number(maxParticipants));

  // Position rewards validation
  const isPositionRewardsValid =
    !enablePositionRewards ||
    (rewardPositions !== "" &&
      Number(rewardPositions) > 0 &&
      Number.isInteger(Number(participationPoints)) &&
      areAllPositionsAssigned());

  // Range rewards validation
  const isRangeRewardsValid =
    !enableRangeRewards ||
    (rangeRewards.length > 0 &&
      rangeRewards.every((r) => r.min && r.max && r.points) &&
      !Object.values(rangeValidationErrors).some(
        (err) => err?.min || err?.max,
      ));

  // Participation rewards validation
  const isParticipationRewardsValid =
    !participationChecked ||
    (participationPoints && Number(participationPoints) > 0);

  // Overall rewards validation - IMPORTANT: has_rewards is only true when assignRewards is true
  const isRewardsValid =
    !assignRewards ||
    (rewardDistributionDate &&
      (enablePositionRewards || enableRangeRewards) &&
      isPositionRewardsValid &&
      isRangeRewardsValid);

  const isParticipationValid =
    !participationChecked ||
    (participationPoints && Number(participationPoints) > 0);

  const isFormValid =
    isBasicFormValid &&
    (assignRewards ? isRewardsValid : true) &&
    isParticipationValid;

  const handleChallangeSubmit = async () => {
    setIsLoading(true);

    const last_registration_date_to_send: string | undefined =
      lastRegistrationDate
        ? new Date(lastRegistrationDate).toISOString()
        : undefined;

    // Build reward_distribution array
    const reward_distribution: any[] = [];

    // Position-based rewards
    if (enablePositionRewards && rewards.length > 0) {
      rewards.forEach((row, idx) => {
        const positionReward: any = {
          distribution_type: "position",
          value: row.position,
          rewards: [],
        };

        // Add voucher/coupon if selected
        if (
          row.reward_value &&
          typeof row.reward_value === "string" &&
          row.reward_value.startsWith("reward-")
        ) {
          const selectedReward = getFilteredRewardsForPosition(
            row.position,
            row.reward_type,
          ).find((r: any) => r.reward_uid === row.reward_value);

          if (selectedReward) {
            positionReward.rewards.push({
              reward_type: row.reward_type.toLowerCase().includes("voucher")
                ? "voucher"
                : "coupon",
              reward_amount: selectedReward.amount,
              reward_name: selectedReward.reward_name,
              reward_uid: selectedReward.reward_uid,
            });
          }
        }

        // Add points if present
        if (pointsValues[idx] && pointsValues[idx] !== "") {
          positionReward.rewards.push({
            reward_type: "points",
            reward_amount: parseInt(pointsValues[idx]),
          });
        }

        if (positionReward.rewards.length > 0) {
          reward_distribution.push(positionReward);
        }
      });
    }

    // Range-based rewards
    if (enableRangeRewards && rangeRewards.length > 0) {
      rangeRewards.forEach((range) => {
        if (range.min && range.max && range.points) {
          reward_distribution.push({
            distribution_type: "range",
            value: {
              range_min: parseInt(range.min),
              range_max: parseInt(range.max),
            },
            rewards: [
              {
                reward_type: "points",
                reward_amount: parseInt(range.points),
                reward_name: "",
                reward_uid: "",
              },
            ],
          });
        }
      });
    }

    try {
      let response;
      if (challengeRecord) {
        // Build reward_distribution for updated payload
        const updatedRewardDistribution: any[] = [];

        // Position-based rewards for update
        if (enablePositionRewards && rewards.length > 0) {
          rewards.forEach((row, idx) => {
            const positionReward: any = {
              distribution_type: "position",
              value: row.position,
              rewards: [],
            };

            if (
              row.reward_value &&
              typeof row.reward_value === "string" &&
              row.reward_value.startsWith("reward-")
            ) {
              const selectedReward = getFilteredRewardsForPosition(
                row.position,
                row.reward_type,
              ).find((r: any) => r.reward_uid === row.reward_value);

              if (selectedReward) {
                positionReward.rewards.push({
                  reward_type: row.reward_type.toLowerCase().includes("voucher")
                    ? "voucher"
                    : "coupon",
                  reward_amount: selectedReward.amount,
                  reward_name: selectedReward.reward_name,
                  reward_uid: selectedReward.reward_uid,
                });
              }
            }

            if (pointsValues[idx] && pointsValues[idx] !== "") {
              positionReward.rewards.push({
                reward_type: "points",
                reward_amount: parseInt(pointsValues[idx]),
              });
            }

            if (positionReward.rewards.length > 0) {
              updatedRewardDistribution.push(positionReward);
            }
          });
        }

        // Range-based rewards for update
        if (enableRangeRewards && rangeRewards.length > 0) {
          rangeRewards.forEach((range) => {
            if (range.min && range.max && range.points) {
              updatedRewardDistribution.push({
                distribution_type: "range",
                value: {
                  range_min: parseInt(range.min),
                  range_max: parseInt(range.max),
                },
                rewards: [
                  {
                    reward_type: "points",
                    reward_amount: parseInt(range.points),
                    reward_name: "",
                    reward_uid: "",
                  },
                ],
              });
            }
          });
        }

        // Calculate participation points
        const participationPointsNum = participationPoints
          ? parseInt(participationPoints)
          : 0;

        // Build the updated data object for comparison
        const updatedData: any = {
          challenge_name: name,
          challenge_desc: description,
          challenge_type: type,
          metric_type: metricType,
          goal_count: typeof count === "string" ? parseInt(count) : count,
          from_datetime: startDateTime
            ? new Date(startDateTime).toISOString()
            : null,
          to_datetime: endDateTime ? new Date(endDateTime).toISOString() : null,
          last_registration_date: lastRegistrationDate
            ? new Date(lastRegistrationDate).toISOString()
            : null,
          visibility,
          max_participants: Number(maxParticipants),
          goal_evaluation_mode: goalEvaluationMode,
          has_rewards: assignRewards,
        };

        // Handle participation points - only include if they exist and are > 0
        if (participationPointsNum > 0) {
          updatedData.has_participation_point = true;
          updatedData.is_experience_point = isExperiencePoint;
          updatedData.participation_point = participationPointsNum;
        } else {
          // If participation points are 0 or empty, explicitly set to false/undefined
          updatedData.has_participation_point = false;
          updatedData.is_experience_point = false;
          // Do NOT include participation_point field at all when it's 0 or empty
          // This will remove it from the challenge
        }

        // Determine if we should include reward_distribution_datetime
        // Only include if:
        // 1. assignRewards is true AND we have some reward distribution configured
        // OR
        // 2. participation points are > 0
        const shouldIncludeRewardDistributionDate =
          (assignRewards &&
            (updatedRewardDistribution.length > 0 ||
              enablePositionRewards ||
              enableRangeRewards)) ||
          participationPointsNum > 0;

        // Only include reward_distribution_datetime if we should AND it has a value
        if (shouldIncludeRewardDistributionDate && rewardDistributionDate) {
          updatedData.reward_distribution_datetime =
            rewardDistributionDate.toISOString();
        } else if (!shouldIncludeRewardDistributionDate) {
          // IMPORTANT FIX: When we shouldn't have a distribution date, explicitly set it to null
          // so getChangedFields can detect the change from the original value
          updatedData.reward_distribution_datetime = null;
        }
        // If shouldIncludeRewardDistributionDate is false and rewardDistributionDate exists,
        // DON'T include it in the payload at all

        // Conditionally add reward_distribution - only if assignRewards is true AND we have rewards
        if (assignRewards && updatedRewardDistribution.length > 0) {
          updatedData.reward_distribution = updatedRewardDistribution;
        } else if (assignRewards && updatedRewardDistribution.length === 0) {
          // If assignRewards is true but no rewards, send empty array
          updatedData.reward_distribution = [];
        }

        // Handle image
        if (selectedFile) {
          updatedData.image = base64Image; // send new image
        } else if (originalData?.image) {
          // Keep original image UID if no new image
          updatedData.image = originalData.image;
        }

        // Handle rules
        updatedData.rule_uids = selectedRules;

        // Get only changed fields
        const changedFields = getChangedFields(originalData, updatedData);

        // Add required fields that should always be present
        changedFields.challenge_uid = challengeRecord.challenge_uid;
        changedFields.org_uid = orgUid;

        // Log for debugging
        console.log("Changed fields to send:", changedFields);
        console.log(
          "Should include reward distribution date:",
          shouldIncludeRewardDistributionDate,
        );
        console.log(
          "Reward distribution date in payload:",
          changedFields.reward_distribution_datetime,
        );

        response = await updateChallenges(sessionUid, userUid, [changedFields]);
      } else {
        // Create new challenge
        const payload: any = {
          org_uid: orgUid,
          challenge_uid: "string",
          challenge_name: name,
          challenge_desc: description,
          challenge_type: type,
          metric_type: metricType,
          visibility: visibility,
          goal_count:
            count !== undefined && count !== null
              ? typeof count === "string"
                ? parseInt(count, 10)
                : count
              : null,
          max_participants: Number(maxParticipants),
          from_datetime: startDateTime
            ? new Date(startDateTime).toISOString()
            : null,
          to_datetime: endDateTime ? new Date(endDateTime).toISOString() : null,
          last_registration_date: last_registration_date_to_send,
          goal_evaluation_mode:
            (challengeDropdownConfig?.goal_evaluation_mode
              ? goalEvaluationMode
              : "") || goalEvaluationMode,
          has_rewards: assignRewards,
        };

        // Handle participation points for new challenge
        const participationPointsNum = participationPoints
          ? parseInt(participationPoints)
          : 0;
        if (participationPointsNum > 0) {
          payload.has_participation_point = true;
          payload.is_experience_point = isExperiencePoint;
          payload.participation_point = participationPointsNum;
        } else {
          payload.has_participation_point = false;
          payload.is_experience_point = false;
          // Don't include participation_point when it's 0
        }

        // Determine if we should include reward_distribution_datetime for new challenge
        const shouldIncludeRewardDistributionDate =
          (assignRewards && reward_distribution.length > 0) ||
          participationPointsNum > 0;

        // Only include reward_distribution_datetime if we should AND it has a value
        if (shouldIncludeRewardDistributionDate && rewardDistributionDate) {
          payload.reward_distribution_datetime =
            rewardDistributionDate.toISOString();
        }

        // Only include reward_distribution if assignRewards is true AND we have rewards
        if (assignRewards && reward_distribution.length > 0) {
          payload.reward_distribution = reward_distribution;
        }

        // image handling
        payload.image = base64Image || "";

        // attach selected rules if any
        if (selectedRules.length > 0) {
          payload.rule_uids = selectedRules;
        }

        response = await addChallenges(sessionUid, userUid, [payload]);
      }

      if (response && response.status === "Success") {
        openNotification({
          type: "success",
          message: response.message || "Challenge saved successfully",
        });
        navigate("/challenges");
      } else {
        openNotification({
          type: "error",
          message: response.data || "Failed to save challenge",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      openNotification({
        type: "error",
        message: "Something went wrong while submitting the challenge",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Simple Switch UI (kept from example)
  const Switch = ({
    checked,
    onChange,
  }: {
    checked: boolean;
    onChange: (v: boolean) => void;
  }) => (
    <label className="switch" style={{ display: "inline-block" }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ display: "none" }}
      />
      <span
        onClick={() => onChange(!checked)}
        style={{
          display: "inline-block",
          width: 44,
          height: 24,
          borderRadius: 20,
          background: checked ? "#007b5e" : "#ccc",
          position: "relative",
          cursor: "pointer",
        }}
      >
        <span
          style={{
            display: "block",
            width: 18,
            height: 18,
            borderRadius: 9,
            background: "white",
            position: "absolute",
            top: 3,
            left: checked ? 23 : 3,
            transition: "left 0.15s",
          }}
        />
      </span>
    </label>
  );

  // Add this useEffect to manage the locking of reward distribution date
  useEffect(() => {
    const hasAnyRewards = enablePositionRewards || enableRangeRewards;

    setIsRewardDistributionLocked(hasAnyRewards);
  }, [enablePositionRewards, enableRangeRewards]);

  const handleRewardChange = (index: number, key: string, value: any) => {
    setRewards((prev) => {
      const copy = [...prev];
      const row = { ...copy[index] };

      if (key === "reward_type") {
        console.log("Reward type changed to:", value);

        const oldRewardType = copy[index].reward_type;
        const oldRewardValue = copy[index].reward_value;

        row.reward_type = value;
        row.reward_value = ""; // Clear reward value when type changes

        // Determine if it's a numeric type
        const isNumericType =
          value.toLowerCase().includes("points") ||
          value.toLowerCase().includes("cash") ||
          value.toLowerCase().includes("amount") ||
          value.toLowerCase() === "points";

        // Determine the API reward type for vouchers/coupons
        let apiRewardType = "";

        if (value.toLowerCase().includes("voucher")) {
          apiRewardType = "voucher";
          row.voucher_unit =
            challengeDropdownConfig?.voucher_unit?.options?.[0] ?? null;
        } else if (value.toLowerCase().includes("coupon")) {
          apiRewardType = "coupon";
          row.voucher_unit = null;
        } else {
          // For other reward types (points, cash, etc.)
          row.voucher_unit = null;
        }

        // Update selected rewards list - remove old value if it was a voucher/coupon
        setSelectedRewardUids((prevSelected) => {
          const newSelected = [...prevSelected];

          // Remove the old value if it exists and was a voucher/coupon UID
          if (
            oldRewardValue &&
            typeof oldRewardValue === "string" &&
            oldRewardValue.length > 10
          ) {
            const oldIndex = newSelected.indexOf(oldRewardValue);
            if (oldIndex > -1) {
              newSelected.splice(oldIndex, 1);
            }
          }

          return newSelected;
        });

        // Fetch rewards only for voucher/coupon types
        if (apiRewardType && rewardDistributionDate) {
          console.log("Fetching rewards for API type:", apiRewardType);
          fetchAvailableRewards(apiRewardType, null, isEditMode);
        }
      } else if (key === "reward_value") {
        // Check if current type is numeric
        const currentType = copy[index].reward_type.toLowerCase();
        const isNumericType =
          currentType.includes("points") ||
          currentType.includes("cash") ||
          currentType.includes("amount") ||
          currentType === "points";

        const oldRewardValue = copy[index].reward_value;

        if (isNumericType) {
          // Parse as number for numeric types
          const numValue = value === "" ? "" : Number(value);
          // Ensure it's a positive integer
          if (
            numValue === "" ||
            (Number.isInteger(numValue) && numValue >= 0)
          ) {
            row.reward_value = numValue;
          }

          // Remove old value from selectedRewardUids if it was a UID
          if (
            oldRewardValue &&
            typeof oldRewardValue === "string" &&
            oldRewardValue.length > 10
          ) {
            setSelectedRewardUids((prev) => {
              const newSelected = [...prev];
              const oldIndex = newSelected.indexOf(oldRewardValue);
              if (oldIndex > -1) {
                newSelected.splice(oldIndex, 1);
              }
              return newSelected;
            });
          }
        } else {
          // For voucher/coupon, keep as string (UID)
          row.reward_value = value;

          // Update selected rewards list for vouchers/coupons
          setSelectedRewardUids((prev) => {
            const newSelected = [...prev];

            // Remove old value if it exists
            if (oldRewardValue && typeof oldRewardValue === "string") {
              const oldIndex = newSelected.indexOf(oldRewardValue);
              if (oldIndex > -1) {
                newSelected.splice(oldIndex, 1);
              }
            }

            // Add new value if it's not empty
            if (value && typeof value === "string") {
              newSelected.push(value);
            }

            return newSelected;
          });
        }
      } else if (key === "voucher_unit") {
        row.voucher_unit = value || null;
      } else {
        (row as any)[key] = value;
      }

      copy[index] = row;
      return copy;
    });
  };

  // const getFilteredRewardsForPosition = (
  //   currentPosition: number,
  //   currentRewardType: string,
  // ) => {
  //   // Determine which reward list to use
  //   const lowerType = currentRewardType.toLowerCase();
  //   let rewardList: any[] = [];

  //   if (lowerType.includes("voucher")) {
  //     rewardList = availableRewards.voucher;
  //   } else if (lowerType.includes("coupon")) {
  //     rewardList = availableRewards.coupon;
  //   } else {
  //     return [];
  //   }

  //   return rewardList.filter((reward) => {
  //     // Check if reward type matches
  //     const lowerRewardType = reward.reward_type?.toLowerCase() || "";

  //     // Match voucher types
  //     if (lowerType.includes("voucher")) {
  //       if (!lowerRewardType.includes("voucher")) {
  //         return false;
  //       }
  //     }
  //     // Match coupon types
  //     else if (lowerType.includes("coupon")) {
  //       if (!lowerRewardType.includes("coupon")) {
  //         return false;
  //       }
  //     }

  //     // Check if this reward is already selected in ANOTHER position
  //     // First, find which reward (if any) is currently selected in this position
  //     const currentPositionReward = rewards[currentPosition - 1];
  //     const isSelectedInCurrentPosition =
  //       currentPositionReward?.reward_value === reward.reward_uid;

  //     // Check if this reward is selected in other positions
  //     const isSelectedInOtherPosition = rewards.some((r, idx) => {
  //       // Skip the current position
  //       if (idx === currentPosition - 1) return false;
  //       // Check if reward type matches and reward value is the same UID
  //       const rType = r.reward_type.toLowerCase();
  //       const isSameType =
  //         (lowerType.includes("voucher") && rType.includes("voucher")) ||
  //         (lowerType.includes("coupon") && rType.includes("coupon"));

  //       return isSameType && r.reward_value === reward.reward_uid;
  //     });

  //     // Allow selection if:
  //     // 1. It's already selected in the current position (so it remains selected)
  //     // OR
  //     // 2. It's not selected in any other position
  //     return isSelectedInCurrentPosition || !isSelectedInOtherPosition;
  //   });
  // };

  const getFilteredRewardsForPosition = (
    currentPosition: number,
    currentRewardType: string,
  ) => {
    // Determine which reward list to use
    const lowerType = currentRewardType.toLowerCase();
    let rewardList: any[] = [];

    if (lowerType.includes("voucher")) {
      rewardList = availableRewards.voucher;
    } else if (lowerType.includes("coupon")) {
      rewardList = availableRewards.coupon;
    } else {
      return [];
    }

    return rewardList.filter((reward) => {
      // Check if reward type matches
      const lowerRewardType = reward.reward_type?.toLowerCase() || "";

      // Match voucher types
      if (lowerType.includes("voucher")) {
        if (!lowerRewardType.includes("voucher")) {
          return false;
        }
      }
      // Match coupon types
      else if (lowerType.includes("coupon")) {
        if (!lowerRewardType.includes("coupon")) {
          return false;
        }
      }

      // Check if this reward is already selected in ANOTHER position
      // First, find which reward (if any) is currently selected in this position
      const currentPositionReward = rewards[currentPosition - 1];
      const isSelectedInCurrentPosition =
        currentPositionReward?.reward_value === reward.reward_uid;

      // Check if this reward is selected in other positions
      const isSelectedInOtherPosition = rewards.some((r, idx) => {
        // Skip the current position
        if (idx === currentPosition - 1) return false;
        // Check if reward type matches and reward value is the same UID
        const rType = r.reward_type.toLowerCase();
        const isSameType =
          (lowerType.includes("voucher") && rType.includes("voucher")) ||
          (lowerType.includes("coupon") && rType.includes("coupon"));

        return isSameType && r.reward_value === reward.reward_uid;
      });

      // In edit mode, we should show ALL rewards (mapped + unused)
      // But filter out rewards that are already assigned to other positions
      if (isEditMode) {
        // Allow selection if:
        // 1. It's already selected in the current position (so it remains selected)
        // 2. It's not selected in any other position
        // 3. OR it's unused (available for assignment)
        return isSelectedInCurrentPosition || !isSelectedInOtherPosition;
      } else {
        // In create mode, only show unused rewards that aren't selected elsewhere
        return !isSelectedInOtherPosition;
      }
    });
  };

  useEffect(() => {
    // Only fetch if we have both distribution date and position rewards enabled
    if (rewardDistributionDate && enablePositionRewards && rewards.length > 0) {
      // Fetch rewards for all unique reward types in the current rewards
      const rewardTypes = [...new Set(rewards.map((r) => r.reward_type))];

      rewardTypes.forEach((rewardType) => {
        if (rewardType === "vouchers" || rewardType === "coupon") {
          const apiRewardType =
            rewardType === "vouchers" ? "voucher" : "coupon";
          console.log(
            "Initial fetch for reward type:",
            apiRewardType,
            "edit mode:",
            isEditMode,
          );
          fetchAvailableRewards(apiRewardType, null, isEditMode);
        }
      });
    }
  }, [
    rewardDistributionDate,
    enablePositionRewards,
    rewards.length,
    isEditMode,
  ]); // Add isEditMode dependency
  return (
    <form
      className="create-challenge-form"
      onSubmit={(e) => e.preventDefault()}
      noValidate
    >
      {isLoading && <Loader />}
      <div
        className="create-challenge"
        style={{
          padding: "20px",
        }}
      >
        <h2 className="create-challenge-heading">
          {challengeRecord ? "Edit Challenge" : "Create Challenge"}
        </h2>
        {/* 1. IMAGE PREVIEW */}
        <div className="challange-image-preview-container">
          {previewImage ? (
            <img
              src={previewImage}
              alt="Selected Preview"
              className="challange-selected-preview-image"
            />
          ) : (
            <span className="challange-image-preview-text">No Image</span>
          )}
          <p className="CreateChallange-preview-text">Preview</p>
        </div>
        <label className="create-challenge-label">
          Select Background Image <span style={{ color: "red" }}>*</span>
          <span
            style={{
              fontSize: "12px",
              color: "#666",
              marginLeft: "8px",
              fontWeight: "normal",
            }}
          >
            (Max size: 5MB, Supported: JPG, PNG)
          </span>
        </label>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          className="create-challenge-image"
          ref={inputRef} // Add ref to clear the input
        />
        <div className="create-challenge-fields">
          {/* 2. Name */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Enter Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="create-challenge-name"
              placeholder="Enter challenge name"
              maxLength={50}
            />
          </div>

          {/* 3. Description */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Enter Description <span style={{ color: "red" }}>*</span>
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="create-challenge-description"
              placeholder="Enter challenge description"
              rows={3}
              maxLength={500}
            />
          </div>

          {/* 4. Metric Type */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Select Metric Type <span style={{ color: "red" }}>*</span>
            </label>
            <select
              value={metricType}
              onChange={(e) => {
                setMetricType(e.target.value);
                const firstCount =
                  challengeDropdownConfig?.config?.[e.target.value]?.goal_count
                    ?.values?.[0] ?? "";
                setCount(firstCount);
              }}
              className="create-challenge-metric"
              disabled={isEditMode}
              style={{
                backgroundColor: isEditMode ? "#f0f0f0" : "white",
                cursor: isEditMode ? "not-allowed" : "pointer",
              }}
            >
              {challengeDropdownConfig?.metric_types?.map((metric: string) => (
                <option key={metric} value={metric}>
                  {metric}
                </option>
              ))}
            </select>
          </div>
          {/* 5. Goal Count */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Enter Goal Count <span style={{ color: "red" }}>*</span>
            </label>

            {challengeDropdownConfig?.config?.[metricType]?.goal_count
              ?.method === "input" ? (
              <input
                type="number"
                value={count}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "") {
                    setCount(value);
                    return;
                  }
                  // Allow only positive integers with max 8 digits
                  if (
                    /^\d+$/.test(value) &&
                    value.length <= 8 &&
                    parseInt(value) > 0
                  ) {
                    setCount(value);
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value !== "") {
                    const config =
                      challengeDropdownConfig?.config?.[metricType]?.goal_count;
                    const min = config?.limit?.min;
                    const max = config?.limit?.max;
                    const unit = config?.unit || "";
                    const numValue = parseInt(value);

                    // Check minimum
                    if (min && numValue < min) {
                      openNotification({
                        type: "error",
                        message: `Goal count for ${metricType} must be at least ${min} ${unit}`,
                      });
                      setCount(min.toString());
                    }
                    // Check maximum
                    else if (max && numValue > max) {
                      openNotification({
                        type: "error",
                        message: `Goal count for ${metricType} cannot exceed ${max} ${unit}`,
                      });
                      setCount(max.toString());
                    }
                  }
                }}
                className="create-challenge-count"
                placeholder={`Enter ${challengeDropdownConfig?.config?.[metricType]?.goal_count?.unit || ""} (${challengeDropdownConfig?.config?.[metricType]?.goal_count?.limit?.min || "N/A"} - ${challengeDropdownConfig?.config?.[metricType]?.goal_count?.limit?.max || "N/A"})`}
              />
            ) : (
              <select
                value={count}
                onChange={(e) => setCount(e.target.value)}
                className="create-challenge-count"
              >
                {challengeDropdownConfig?.config?.[
                  metricType
                ]?.goal_count?.values?.map((val: number) => (
                  <option key={val} value={val}>
                    {val}{" "}
                    {
                      challengeDropdownConfig?.config?.[metricType]?.goal_count
                        ?.unit
                    }
                  </option>
                ))}
              </select>
            )}
          </div>

          {/* 6. Challenge Type */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Challenge Type <span style={{ color: "red" }}>*</span>
            </label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="create-challenge-visibility"
            >
              {challengeDropdownConfig?.challenge_type?.options?.map(
                (opt: string) => (
                  <option key={opt} value={opt}>
                    {opt.charAt(0).toUpperCase() + opt.slice(1)}
                  </option>
                ),
              )}
            </select>
          </div>

          {/* 7. Goal Evaluation Mode */}
          {challengeDropdownConfig?.goal_evaluation_mode?.options && (
            <div className="create-challenge-field">
              <label className="create-challenge-label">
                Goal Evaluation Mode <span style={{ color: "red" }}>*</span>
              </label>
              <select
                value={
                  challengeDropdownConfig
                    ? challengeDropdownConfig.goal_evaluation_mode
                      ? challengeDropdownConfig.goal_evaluation_mode.options.includes(
                          goalEvaluationMode,
                        )
                        ? goalEvaluationMode
                        : challengeDropdownConfig.goal_evaluation_mode
                            .options[0]
                      : goalEvaluationMode
                    : goalEvaluationMode
                }
                onChange={(e) => setGoalEvaluationMode(e.target.value)}
                className="create-challenge-goal-mode"
              >
                {challengeDropdownConfig.goal_evaluation_mode.options.map(
                  (opt: string) => (
                    <option key={opt} value={opt}>
                      {opt.charAt(0).toUpperCase() + opt.slice(1)}
                    </option>
                  ),
                )}
              </select>
            </div>
          )}

          {/* 8. Visibility */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Select Visibility <span style={{ color: "red" }}>*</span>
            </label>
            <select
              value={visibility}
              onChange={(e) => setVisibility(e.target.value)}
              className="create-challenge-visibility"
            >
              {challengeDropdownConfig?.visibility?.options?.map(
                (opt: string) => (
                  <option key={opt} value={opt}>
                    {opt.charAt(0).toUpperCase() + opt.slice(1)}
                  </option>
                ),
              )}
            </select>
          </div>

          {/* 9. Max Participants */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Max Participants <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              value={maxParticipants}
              onChange={(e) => {
                const value = e.target.value;

                // Allow empty value (for backspace)
                if (value === "") {
                  setMaxParticipants(value);
                  return;
                }

                // Allow only positive integers with max 8 digits
                if (
                  /^\d+$/.test(value) && // digits only
                  value.length <= 8 && // 👈 8 digit restriction
                  parseInt(value) > 0
                ) {
                  setMaxParticipants(value);
                }
              }}
              min="1"
              className="create-challenge-prize"
              placeholder="Enter Max Participants"
              style={{
                backgroundColor: isEditMode ? "#f0f0f0" : "white",
                cursor: isEditMode ? "not-allowed" : "text",
              }}
              disabled={isEditMode}
            />
          </div>

          {/* 10. Start Date */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Start Date <span style={{ color: "red" }}>*</span>
            </label>
            <Flatpickr
              className="create-challenge-start-datetime"
              value={startDateTime || ""}
              onChange={(dates: Date[]) => setStartDateTime(dates[0] || "")}
              options={{
                enableTime: true,
                dateFormat: "Y-m-d H:i",
                time_24hr: true,
                minuteIncrement: 1,
                disableMobile: true,
                allowInput: true,
                clickOpens: !isEditMode,
              }}
              disabled={isEditMode}
            />
          </div>

          {/* 11. End Date */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              End Date <span style={{ color: "red" }}>*</span>
            </label>
            <Flatpickr
              className="create-challenge-end-datetime"
              value={endDateTime || ""}
              onChange={(selectedDates: Date[]) => {
                if (selectedDates.length > 0) {
                  const newEndDate = selectedDates[0];

                  // Check if rewards are configured
                  if (
                    rewardDistributionDate &&
                    (enablePositionRewards ||
                      enableRangeRewards ||
                      participationChecked)
                  ) {
                    if (
                      window.confirm(
                        "Changing the end date will clear all reward configurations. Do you want to continue?",
                      )
                    ) {
                      setEndDateTime(newEndDate);
                      // Clear rewards
                      setRewardDistributionDate(null);
                      setRewards([]);
                      setRangeRewards([]);
                      setRangeValidationErrors({});
                      setParticipationPoints("");
                      setIsExperiencePoint(false);
                      setEnablePositionRewards(false);
                      setEnableRangeRewards(false);
                      setParticipationChecked(false);
                      setShowPointsInput({});
                      setPointsValues({});
                      setSelectedRewardUids([]);
                      setAvailableRewards({ voucher: [], coupon: [] });

                      openNotification({
                        type: "warning",
                        message:
                          "All reward configurations have been cleared due to end date change.",
                      });
                    }
                  } else {
                    setEndDateTime(newEndDate);
                  }
                }
              }}
              options={{
                enableTime: true,
                dateFormat: "Y-m-d H:i",
                time_24hr: true,
                minuteIncrement: 1,
                allowInput: true,
                disableMobile: true,
                position: "auto center",
                minDate: startDateTime ? new Date(startDateTime) : "",
              }}
            />
          </div>

          {/* 12. Last Registration Date */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Last Registration Date <span style={{ color: "red" }}>*</span>
            </label>
            <Flatpickr
              className="create-challenge-registration-datetime"
              value={lastRegistrationDate || ""}
              onChange={(dates: Date[]) =>
                setLastRegistrationDate(dates[0] || "")
              }
              options={{
                enableTime: true,
                dateFormat: "Y-m-d H:i",
                // minDate: "today",
                minDate: !isEditMode ? "today" : "",
                maxDate: startDateTime
                  ? new Date(
                      new Date(startDateTime).getTime() +
                        2 * 24 * 60 * 60 * 1000,
                    )
                  : "",
                disableMobile: true,
              }}
              disabled={isEditMode || !startDateTime}
            />
          </div>

          {/* 12. Participation Points */}
          <div className="create-challenge-field">
            <label className="create-challenge-label">
              Participation Points
            </label>
            <input
              type="number"
              value={participationPoints}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only positive integers (including 0 for "no participation points")
                if (
                  value === "" ||
                  (parseInt(value) >= 0 && Number.isInteger(Number(value)))
                ) {
                  setParticipationPoints(value);

                  // Set participationChecked to true if value is entered AND greater than 0
                  const hasParticipation = value !== "" && Number(value) > 0;
                  setParticipationChecked(hasParticipation);

                  // If participation points are empty or 0, set isExperiencePoint to false
                  if (value === "" || Number(value) <= 0) {
                    setIsExperiencePoint(false);
                  }
                }
              }}
              className="create-challenge-participation-points"
              placeholder="Enter points for participation"
              min="0"
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                backgroundColor: "white",
                cursor: "text",
              }}
            />
          </div>

          {/* SINGLE REWARD DISTRIBUTION DATE FIELD - Shows when either assignRewards is ON OR participation points are entered */}
          {(assignRewards ||
            (participationPoints !== "" &&
              Number(participationPoints) > 0)) && (
            <div className="create-challenge-field">
              <label className="create-challenge-label">
                Reward Distribution Date <span style={{ color: "red" }}>*</span>
              </label>
              <Flatpickr
                className="create-challenge-distribution-datetime"
                value={rewardDistributionDate || ""}
                onChange={(selectedDates: Date[]) => {
                  if (selectedDates.length > 0) {
                    const newDistDate = selectedDates[0];

                    // Check if rewards are configured
                    if (
                      rewardDistributionDate &&
                      (enablePositionRewards ||
                        enableRangeRewards ||
                        participationChecked)
                    ) {
                      // Show confirmation dialog
                      setPendingDistributionDate(newDistDate);
                      setShowDateChangeConfirm(true);
                    } else {
                      setRewardDistributionDate(newDistDate);
                    }
                  }
                }}
                options={{
                  enableTime: true,
                  dateFormat: "Y-m-d H:i",
                  time_24hr: true,
                  minDate: endDateTime || "",
                  maxDate: endDateTime
                    ? new Date(
                        new Date(endDateTime).getTime() +
                          2 * 24 * 60 * 60 * 1000,
                      )
                    : "",
                  disableMobile: true,
                }}
                disabled={!endDateTime}
                style={{
                  backgroundColor: !endDateTime ? "#f0f0f0" : "white",
                  cursor: !endDateTime ? "not-allowed" : "text",
                }}
              />
              {!endDateTime && (
                <p
                  style={{ fontSize: "12px", color: "#999", marginTop: "4px" }}
                >
                  Please select End Date first
                </p>
              )}
            </div>
          )}
        </div>
        {participationPoints !== "" && Number(participationPoints) > 0 && (
          <div
            style={{
              marginTop: "12px",
              padding: "12px",
            }}
          >
            <label
              style={{
                fontSize: "16px",
                color: "#333",
                fontWeight: 500,
                display: "block",
                marginBottom: "8px",
              }}
            >
              Do you want to consider participation points as experience points?
            </label>

            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="radio"
                  name="experiencePoints"
                  checked={isExperiencePoint === true}
                  onChange={() => setIsExperiencePoint(true)}
                  style={{
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: "14px", color: "#333" }}>Yes</span>
              </label>

              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="radio"
                  name="experiencePoints"
                  checked={isExperiencePoint === false}
                  onChange={() => setIsExperiencePoint(false)}
                  style={{
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: "14px", color: "#333" }}>No</span>
              </label>
            </div>
          </div>
        )}
        {/* 13. Assign Rewards switch */}
        <div
          className="create-challenge-field"
          style={{ display: "flex", alignItems: "center", gap: 12 }}
        >
          <label className="create-challenge-label">Assign Rewards?</label>
          <Switch checked={assignRewards} onChange={setAssignRewards} />
        </div>

        {/* Rewards section (shows only if switch ON) */}
        {assignRewards && (
          <div className="rewards-configuration">
            <h4>Rewards Configuration</h4>

            {/* Note: Reward Distribution Date is now shown above in the main form fields */}

            {/* 1. POSITION BASED REWARDS - Collapsible */}
            <div
              className={`reward-section ${
                !rewardDistributionDate ? "disabled" : ""
              }`}
              style={{
                opacity: !rewardDistributionDate ? 0.5 : 1,
                pointerEvents: !rewardDistributionDate ? "none" : "auto",
              }}
            >
              <div
                className="reward-section-header"
                style={{
                  cursor: rewardDistributionDate ? "pointer" : "not-allowed",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", flex: 1 }}
                  onClick={() => {
                    if (!rewardDistributionDate) return;
                    setEnablePositionRewards(!enablePositionRewards);
                    if (!enablePositionRewards) {
                      setRewardPositions("3");
                    } else {
                      setRewardPositions("");
                      setRewards([]);
                      setSelectedRewardUids([]);
                      setAvailableRewards({ voucher: [], coupon: [] });
                      setShowPointsInput({});
                      setPointsValues({});
                    }
                  }}
                >
                  <span style={{ fontSize: "18px", marginRight: "8px" }}>
                    {enablePositionRewards ? "▼" : "▶"}
                  </span>
                  <label style={{ flex: 1, cursor: "inherit" }}>
                    Position Based Rewards
                  </label>
                </div>
                {enablePositionRewards && (
                  <button
                    type="button"
                    className="clear-reward-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setRewards([]);
                      setSelectedRewardUids([]);
                      setAvailableRewards({ voucher: [], coupon: [] });
                      setShowPointsInput({});
                      setPointsValues({});
                      setRewardPositions("");
                      setEnablePositionRewards(false);
                    }}
                  >
                    Clear Rewards
                  </button>
                )}
              </div>

              {enablePositionRewards && (
                <div className="reward-section-content">
                  <div className="position-input-group">
                    <label>Number of Positions (Max 10)</label>
                    <input
                      type="number"
                      min="1"
                      max="10"
                      value={rewardPositions}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (
                          val === "" ||
                          (parseInt(val) >= 1 && parseInt(val) <= 10)
                        ) {
                          setRewardPositions(val);
                        }
                      }}
                      placeholder="Enter number of positions (1-10)"
                    />
                  </div>

                  <div className="reward-positions-grid">
                    {rewards.map((row, idx) => {
                      const isVoucherCouponType =
                        row.reward_type.toLowerCase().includes("voucher") ||
                        row.reward_type.toLowerCase().includes("coupon");

                      const selectedRewardDetails = isVoucherCouponType
                        ? getFilteredRewardsForPosition(
                            row.position,
                            row.reward_type,
                          ).find((r: any) => r.reward_uid === row.reward_value)
                        : null;

                      return (
                        <div key={idx} className="reward-row">
                          <div className="position-label">
                            Position {row.position}
                          </div>

                          <div className="reward-two-section-container">
                            {/* LEFT SECTION */}
                            <div className="reward-left-section">
                              {type === "team" ? (
                                <div className="team-reward-message">
                                  <p
                                    style={{
                                      color: "#ff9800",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    Vouchers and Coupons cannot be assigned for
                                    team challenges
                                  </p>
                                </div>
                              ) : (
                                <>
                                  <div className="reward-field">
                                    <label>Reward Type</label>
                                    <select
                                      value={row.reward_type}
                                      onChange={(e) =>
                                        handleRewardChange(
                                          idx,
                                          "reward_type",
                                          e.target.value,
                                        )
                                      }
                                      className="reward-type-select"
                                    >
                                      <option value="">
                                        Select Reward Type
                                      </option>
                                      <option value="vouchers">Vouchers</option>
                                      <option value="coupon">Coupons</option>
                                    </select>
                                  </div>

                                  {isVoucherCouponType && (
                                    <div className="reward-field">
                                      <label>Select Reward</label>
                                      {!selectedRewardDetails ? (
                                        <button
                                          type="button"
                                          className="select-reward-button"
                                          onClick={() => openRewardModal(idx)}
                                          disabled={
                                            !row.reward_type ||
                                            !rewardDistributionDate
                                          }
                                        >
                                          Select Reward
                                        </button>
                                      ) : (
                                        <div
                                          className={`selected-reward-card ${
                                            idx % 3 === 0
                                              ? "green-card"
                                              : idx % 3 === 1
                                                ? "purple-card"
                                                : "blue-card"
                                          }`}
                                        >
                                          <img
                                            src={
                                              selectedRewardDetails.image
                                                ? `data:image/png;base64,${selectedRewardDetails.image}`
                                                : coinIcon
                                            }
                                            alt={
                                              selectedRewardDetails.reward_name
                                            }
                                          />
                                          <div className="selected-reward-info">
                                            <h4>
                                              {
                                                selectedRewardDetails.reward_name
                                              }
                                            </h4>
                                            <p className="reward-amount-display">
                                              {selectedRewardDetails.amount}{" "}
                                              {selectedRewardDetails.currency}
                                            </p>
                                          </div>
                                          <button
                                            type="button"
                                            className="cancel-reward-button"
                                            onClick={() => {
                                              handleRewardChange(
                                                idx,
                                                "reward_value",
                                                "",
                                              );
                                              setShowPointsInput((prev) => ({
                                                ...prev,
                                                [idx]: false,
                                              }));
                                              setPointsValues((prev) => ({
                                                ...prev,
                                                [idx]: "",
                                              }));
                                            }}
                                          >
                                            ✕
                                          </button>
                                        </div>
                                      )}

                                      {row.reward_type
                                        .toLowerCase()
                                        .includes("voucher") &&
                                        challengeDropdownConfig?.voucher_unit
                                          ?.options && (
                                          <div className="voucher-unit-field">
                                            <label>Voucher Unit</label>
                                            <select
                                              value={row.voucher_unit || ""}
                                              onChange={(e) =>
                                                handleRewardChange(
                                                  idx,
                                                  "voucher_unit",
                                                  e.target.value,
                                                )
                                              }
                                              className="voucher-unit-select"
                                            >
                                              <option value="">
                                                Select unit
                                              </option>
                                              {challengeDropdownConfig.voucher_unit.options.map(
                                                (u: string) => (
                                                  <option key={u} value={u}>
                                                    {u}
                                                  </option>
                                                ),
                                              )}
                                            </select>
                                          </div>
                                        )}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>

                            {/* VERTICAL DIVIDER */}
                            <div className="reward-vertical-divider"></div>

                            {/* RIGHT SECTION - Points */}
                            <div className="reward-right-section">
                              {!showPointsInput[idx] ? (
                                <button
                                  type="button"
                                  className="add-points-toggle-button"
                                  onClick={() => {
                                    setShowPointsInput((prev) => ({
                                      ...prev,
                                      [idx]: true,
                                    }));
                                  }}
                                >
                                  + Add Points
                                </button>
                              ) : (
                                <div className="reward-field">
                                  <label>Enter Reward Points</label>
                                  <input
                                    type="number"
                                    min="0"
                                    step="1"
                                    value={pointsValues[idx] || ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // Allow only positive integers
                                      if (
                                        value === "" ||
                                        (parseInt(value) >= 0 &&
                                          Number.isInteger(Number(value)))
                                      ) {
                                        setPointsValues((prev) => ({
                                          ...prev,
                                          [idx]: value,
                                        }));
                                      }
                                    }}
                                    placeholder="Enter positive integer"
                                    className="reward-points-input"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* 2. RANGE BASED REWARDS - Collapsible */}
            {type !== "team" && assignRewards && (
              <div
                className={`reward-section ${
                  !rewardDistributionDate ? "disabled" : ""
                }`}
                style={{
                  opacity: !rewardDistributionDate ? 0.5 : 1,
                  pointerEvents: !rewardDistributionDate ? "none" : "auto",
                }}
              >
                <div
                  className="reward-section-header"
                  style={{
                    cursor: rewardDistributionDate ? "pointer" : "not-allowed",
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", flex: 1 }}
                    onClick={() => {
                      if (!rewardDistributionDate) return;
                      setEnableRangeRewards(!enableRangeRewards);
                      if (!enableRangeRewards) {
                        // Optionally add a default range
                      } else {
                        setRangeRewards([]);
                        setRangeValidationErrors({});
                      }
                    }}
                  >
                    <span style={{ fontSize: "18px", marginRight: "8px" }}>
                      {enableRangeRewards ? "▼" : "▶"}
                    </span>
                    <label style={{ flex: 1, cursor: "inherit" }}>
                      Range Based Rewards
                    </label>
                  </div>
                  {enableRangeRewards && (
                    <button
                      type="button"
                      className="clear-reward-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setRangeRewards([]);
                        setRangeValidationErrors({});
                        setEnableRangeRewards(false);
                      }}
                    >
                      Clear Rewards
                    </button>
                  )}
                </div>

                {enableRangeRewards && (
                  <div className="reward-section-content">
                    <button
                      className="add-range-button"
                      onClick={addRangeReward}
                    >
                      <span>+</span> Add Range
                    </button>

                    {rangeRewards.length > 0 ? (
                      <div className="range-rewards-list">
                        {rangeRewards.map((row, idx) => {
                          const usedPositions = parseInt(rewardPositions) || 0;
                          const minAllowed = usedPositions + 1;
                          const maxAllowed = parseInt(maxParticipants) || 100;

                          return (
                            <div key={idx} className="range-reward-card">
                              <div className="range-reward-header">
                                <span className="range-label">
                                  Range {idx + 1}
                                </span>
                                <button
                                  className="remove-range-button-icon"
                                  onClick={() => {
                                    setRangeRewards(
                                      rangeRewards.filter((_, i) => i !== idx),
                                    );
                                    // Clear validation errors for removed range
                                    setRangeValidationErrors((prev) => {
                                      const updated = { ...prev };
                                      delete updated[idx];
                                      return updated;
                                    });
                                  }}
                                >
                                  ✕
                                </button>
                              </div>

                              <div className="range-fields-group">
                                <div className="range-field">
                                  <label>Min Position</label>
                                  <input
                                    type="number"
                                    min={minAllowed}
                                    value={row.min}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      handleRangeChange(idx, "min", value);

                                      // Validate after updating
                                      const validation = validateRangeRewards(
                                        idx,
                                        "min",
                                        value,
                                      );
                                      setRangeValidationErrors((prev) => ({
                                        ...prev,
                                        [idx]: {
                                          ...prev[idx],
                                          min: validation.isValid
                                            ? undefined
                                            : validation.message,
                                        },
                                      }));
                                    }}
                                    placeholder={`Min: ${minAllowed}`}
                                    style={{
                                      borderColor: rangeValidationErrors[idx]
                                        ?.min
                                        ? "#ff4d4f"
                                        : undefined,
                                    }}
                                  />
                                  <span className="field-hint">
                                    Min: {minAllowed}
                                  </span>
                                  {rangeValidationErrors[idx]?.min && (
                                    <span
                                      className="field-error"
                                      style={{
                                        color: "#ff4d4f",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {rangeValidationErrors[idx].min}
                                    </span>
                                  )}
                                </div>

                                <div className="range-field">
                                  <label>Max Position</label>
                                  <input
                                    type="number"
                                    max={maxAllowed}
                                    value={row.max}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      handleRangeChange(idx, "max", value);

                                      // Validate after updating
                                      const validation = validateRangeRewards(
                                        idx,
                                        "max",
                                        value,
                                      );
                                      setRangeValidationErrors((prev) => ({
                                        ...prev,
                                        [idx]: {
                                          ...prev[idx],
                                          max: validation.isValid
                                            ? undefined
                                            : validation.message,
                                        },
                                      }));
                                    }}
                                    placeholder={`Max: ${maxAllowed}`}
                                    style={{
                                      borderColor: rangeValidationErrors[idx]
                                        ?.max
                                        ? "#ff4d4f"
                                        : undefined,
                                    }}
                                  />
                                  <span className="field-hint">
                                    Max: {maxAllowed}
                                  </span>
                                  {rangeValidationErrors[idx]?.max && (
                                    <span
                                      className="field-error"
                                      style={{
                                        color: "#ff4d4f",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {rangeValidationErrors[idx].max}
                                    </span>
                                  )}
                                </div>

                                <div className="range-field">
                                  <label>Points</label>
                                  <input
                                    type="number"
                                    min="0"
                                    value={row.points}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // Allow only positive integers
                                      if (
                                        value === "" ||
                                        (parseInt(value) >= 0 &&
                                          Number.isInteger(Number(value)))
                                      ) {
                                        handleRangeChange(idx, "points", value);
                                      }
                                    }}
                                    placeholder="Points"
                                  />
                                </div>
                              </div>

                              {row.min &&
                                row.max &&
                                row.points &&
                                !rangeValidationErrors[idx]?.min &&
                                !rangeValidationErrors[idx]?.max && (
                                  <div className="range-display-badge">
                                    Positions {row.min}-{row.max}: {row.points}{" "}
                                    points
                                  </div>
                                )}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="empty-state">No ranges added yet</div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <Modal
          isOpen={isRewardModalOpen}
          onRequestClose={() => {
            setIsRewardModalOpen(false);
            setCurrentPositionIndex(null);
          }}
          className="reward-selection-modal"
          overlayClassName="challange-custom-overlay"
        >
          <button
            className="modal-close-button"
            onClick={() => {
              setIsRewardModalOpen(false);
              setCurrentPositionIndex(null);
            }}
          >
            &times;
          </button>

          <h2 style={{ marginBottom: "20px", color: "#333" }}>Select Reward</h2>

          {currentPositionIndex !== null && (
            <div className="rewards-grid">
              {getFilteredRewardsForPosition(
                rewards[currentPositionIndex].position,
                rewards[currentPositionIndex].reward_type,
              ).length > 0 ? (
                getFilteredRewardsForPosition(
                  rewards[currentPositionIndex].position,
                  rewards[currentPositionIndex].reward_type,
                ).map((reward: any, index: number) => {
                  // Determine color class based on index (Cycle: Green, Purple, Blue)
                  const colorClass =
                    index % 3 === 0
                      ? "green-card"
                      : index % 3 === 1
                        ? "purple-card"
                        : "blue-card";

                  return (
                    <div
                      key={reward.reward_uid}
                      className={`reward-selection-card ${colorClass}`}
                      onClick={() => handleRewardSelection(reward)}
                    >
                      <img
                        src={
                          reward.image
                            ? `data:image/png;base64,${reward.image}`
                            : coinIcon
                        }
                        alt={reward.reward_name}
                      />

                      <h3>{reward.reward_name}</h3>

                      <span className={`reward-badge ${reward.reward_type}`}>
                        {reward.reward_type}
                      </span>

                      <span className="amount-value">
                        Price: {reward.amount} {reward.currency}
                      </span>

                      <button className="select-button">Select</button>
                    </div>
                  );
                })
              ) : (
                <div className="no-rewards-message">
                  <p>No rewards available for this reward type.</p>
                  <p>
                    Please check the distribution date or reward type selection.
                  </p>
                </div>
              )}
            </div>
          )}
        </Modal>

        {/* Date Change Confirmation Modal */}
        {showDateChangeConfirm && (
          <div
            className="confirmation-modal-overlay"
            onClick={handleCancelDateChange}
          >
            <div
              className="confirmation-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="confirmation-modal-header">
                <h3>⚠️ Confirm Date Change</h3>
              </div>
              <div className="confirmation-modal-body">
                <p>
                  Changing the reward distribution date will clear all reward
                  configurations including:
                </p>
                <ul>
                  <li>Position-based rewards</li>
                  <li>Range-based rewards</li>
                </ul>
                <p>
                  <strong>Do you want to continue?</strong>
                </p>
              </div>
              <div className="confirmation-modal-footer">
                <button
                  className="confirmation-cancel-btn"
                  onClick={handleCancelDateChange}
                >
                  Cancel
                </button>
                <button
                  className="confirmation-confirm-btn"
                  onClick={handleConfirmDateChange}
                >
                  Yes, Change Date
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Rules display (kept) */}
        {showRules && rulesList.length > 0 && (
          <div className="rules-display">
            <label className="create-challenge-label">
              Available Rules <span style={{ color: "red" }}>*</span>{" "}
            </label>
            <ul>
              {rulesList.map((rule: any, idx: number) => (
                <li key={idx}>{rule.rule_name || rule.rule_uid}</li>
              ))}
            </ul>
          </div>
        )}
        {/* Submit button */}
        <div style={{ marginTop: 16 }}>
          <button
            type="button"
            className="create-challenge-submit"
            disabled={!isFormValid}
            onClick={handleChallangeSubmit}
          >
            {challengeRecord ? "Update Challenge" : "Create Challenge"}
          </button>
        </div>
      </div>

      {isCropModalOpen && tempImageForCrop && (
        <CropModalContainer>
          <div className="crop-wrap">
            <Cropper
              image={tempImageForCrop}
              crop={crop}
              zoom={zoom}
              aspect={16 / 9}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={(_, pixels) => setCroppedAreaPixels(pixels)}
            />
          </div>
          <div className="controls">
            <input
              type="range"
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
            />
            <div className="buttons">
              <button onClick={handleCropSave}>Save</button>
              <button
                className="cancel"
                onClick={() => {
                  setIsCropModalOpen(false);
                  setTempImageForCrop(null);
                  if (inputRef.current) inputRef.current.value = "";
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </CropModalContainer>
      )}
    </form>
  );
};

export default CreateChallenges;
